import { createFileRoute } from '@tanstack/react-router';
import { GreetLogo } from '@/components/brand/GreetLogo';

// The Firefox extension's sign-in return page. The tokens ride in the URL hash, which
// never reaches a server; the extension reads them from the tab and closes it.
export const Route = createFileRoute('/extension-signed-in')({
  ssr: false,
  // Drop the tokens from the address before anything (analytics included) can read it.
  beforeLoad: () => {
    if (window.location.hash) window.history.replaceState(null, '', window.location.pathname);
  },
  component: ExtensionSignedInPage,
});

function ExtensionSignedInPage() {
  return (
    <main className="dark flex min-h-dvh items-center justify-center bg-[#090909] px-4 text-white antialiased">
      <div className="w-full max-w-[360px]">
        <GreetLogo className="h-8 w-auto" />
        <h1 className="mt-10 text-[28px] font-semibold leading-tight tracking-[-0.01em]">You’re signed in</h1>
        <p className="mt-2 text-[15px] text-white/60">You can close this tab and go back to Netflix.</p>
      </div>
    </main>
  );
}
